import * as React from 'react';
import styled from 'styled-components';


interface InputProps {
  shape?: 'normal' | 'large' | 'small' | undefined;
  disabled?: boolean;
  children: React.ReactNode;
}

const InputAreaStyle = ({ shape = 'normal', disabled = false, children}: InputProps) => {
  return (
  <Wrap shape={shape} disabled={disabled}>
    {children}
  </Wrap>
)}


export default InputAreaStyle;


interface StyleProps {
  shape: 'normal' | 'large' | 'small' | undefined;
  disabled: boolean;
}


const FuncWrap = (p:StyleProps) => {
  const padding = 'padding: 0 ';
  let paddingNum = '';
  const height = 'height:';
  let heightNum = '';
  const line = 'line-height:';
  let lineNum = '';
  const font = 'font-size:'
  let fontNum = '';

  switch(p.shape) {
    // case 'large': heightNum = '50px'; fontNum = '18px'; break;
    case 'small': paddingNum = '10px'; heightNum = '30px'; lineNum = '29px'; fontNum = '12px' ; break;
    case 'normal':
    default: paddingNum = '20px'; heightNum = '40px'; lineNum = '39px'; fontNum = '14px' ; break;
  }

  const resultShape = `${padding}${paddingNum}; ${height}${heightNum}; ${line}${lineNum}; ${font}${fontNum};`;

  const color = 'color:';
  let colorNum = '#666';
  const border = 'border: 1px solid ';
  let bdColorNum = '#cfcfcf';
  const bg = 'background-color:';
  let bgColorNum = '#fff';

  if (p.disabled) {
    colorNum = '#bababa'; bdColorNum = '#cfcfcf'; bgColorNum = '#f9f9f9';
  }

  const resultColor = `${color}${colorNum};${border}${bdColorNum};${bg}${bgColorNum};`

  return resultShape + resultColor;
};

const FuncInput = (p:StyleProps) => {
  const height = 'height:';
  let heightNum = '';
  const font = 'font-size:'
  let fontNum = '';

  switch(p.shape) {
    // case 'large': heightNum = '50px'; fontNum = '18px'; break;
    case 'small': heightNum = '28px'; fontNum = '12px' ; break;
    case 'normal':
    default: heightNum = '38px'; fontNum = '14px' ; break;
  }

  const resultShape = `${height}${heightNum}; ${font}${fontNum};`;

  return resultShape;
}

const Wrap = styled.div<StyleProps>`
  display: inline-block;
  position: relative;
  border-radius: 3px;
  ${p => FuncWrap(p)}

  &.focus {
    border-color: #b6aa92;
  }

  & input {
    vertical-align: top;
    ${p => FuncInput(p)}
  }
`;


// WEBPACK FOOTER //
// ./src/styles/ui/InputArea.tsx